module.exports = __webpack_public_path__ + "img/FachadaBristol-2.1c183b59.jpg";